module.exports = __webpack_public_path__ + "static/example-02-main-c743d42cc3f34feacbc48831512b7b9d.png";